"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Calendar, Plus, PieChart, Home } from "lucide-react";
import { cn } from "@/lib/utils";

const items = [
  { href: "/", label: "홈", icon: Home },
  { href: "/budget", label: "캘린더", icon: Calendar },
  { href: "/budget/add", label: "입력", icon: Plus, primary: true },
  { href: "/budget/stats", label: "통계", icon: PieChart },
];

export function BottomNav() {
  const pathname = usePathname();
  const show = pathname.startsWith("/budget") && pathname !== "/budget/add";
  if (!show) return null;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-[var(--border)] bg-[var(--background)]/90 backdrop-blur-xl"
      style={{ paddingBottom: "var(--safe-bottom)" }}
    >
      <div className="mx-auto grid max-w-[480px] grid-cols-4">
        {items.map(({ href, label, icon: Icon, primary }) => {
          const active = href === "/budget" ? pathname === "/budget" : pathname === href;
          return (
            <Link
              key={href}
              href={href}
              className={cn(
                "flex flex-col items-center gap-1 py-3 text-xs transition-colors",
                active ? "text-[var(--foreground)]" : "text-[var(--muted)]",
              )}
            >
              <span
                className={cn(
                  "flex h-10 w-10 items-center justify-center rounded-full transition-all",
                  primary && "bg-[var(--accent)] text-white shadow-lg shadow-[var(--accent)]/30",
                  !primary && active && "bg-[var(--surface-2)]",
                )}
              >
                <Icon size={primary ? 22 : 20} strokeWidth={primary ? 2.5 : 2} />
              </span>
              <span>{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
